import { Module } from '@rygen/rygen-ui/model';
import { generateAppUrl } from '@rygen/rygen-ui/util';

import {
  EmbeddableLocation,
  RoutingGuideRule,
  ShipmentRelatedInvoiceReference,
} from '@/model';

export const generateRoutingGuideLink = (
  routingGuideRule: RoutingGuideRule,
  domainNaturalId?: string,
) => {
  return generateAppUrl(
    Module.FICON,
    `routing-guide/${routingGuideRule.id}`,
    domainNaturalId,
  );
};

export const generateLocationLink = (
  location: EmbeddableLocation,
  domainNaturalId?: string,
) => {
  return generateAppUrl(
    Module.FICON,
    `location/${location.locationId}`,
    domainNaturalId,
  );
};

export const generateCarrierInvoiceLink = (
  invoice: ShipmentRelatedInvoiceReference,
  domainNaturalId?: string,
) => {
  return generateAppUrl(
    Module.BILLING,
    `carrier/invoice/${invoice.invoiceId}`,
    domainNaturalId,
  );
};
